import React from 'react';
import ReactDOM from 'react-dom';
import styles from './HoverPopover.module.css';

// ✨ Add onMouseOver and onMouseLeave to the props
const HoverPopover = ({ product, position, onUpdate, onMouseOver, onMouseLeave }) => {
  if (!product || !position) {
    return null;
  }

  const popoverStyle = {
    top: `${position.top}px`,
    left: `${position.left}px`,
  };


  return ReactDOM.createPortal(
    <div 
      className={styles.popover} 
      style={popoverStyle}
      // Prevent the popover from disappearing when the mouse moves onto it
      onMouseOver={onMouseOver}
      onMouseLeave={onMouseLeave}
    >
      <div className={styles.content}>
        <span className={styles.descriptionText}>
          {product.notes?.trim() ? product.notes : 'No description available.'}
        </span>
        {onUpdate && (
          <button
            className={styles.updateButton}
            onClick={() => onUpdate(product)}
          >
            Update
          </button>
        )}
      </div>
      {/* The caret is now created with CSS only */}
    </div>,
    document.getElementById('popover-root')
  );
};

export default HoverPopover;